'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { FaRegCircleUser } from 'react-icons/fa6';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export const HeaderProfileButton = () => {
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);
  const isInicialized = useCustomerStore(s => s.isInitialized);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  const isAuthorited = me && me?.customer && isInicialized;

  if (isAuthorited)
    return (
      <Button variant={'secondary'} asChild size={'icon'}>
        <Link prefetch={false} href={ROUTES.PROFILE()} aria-label="Profil">
          <FaRegCircleUser size={18} />
        </Link>
      </Button>
    );

  return (
    <Button onClick={handleSignInClick} variant="secondary" size={'icon'}>
      <Image
        src={'/images/icons/profile-add.svg'}
        alt="Profil"
        width={24}
        height={24}
        className="object-contain"
      />
    </Button>
  );
};
